import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-lg border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary: 'bg-secondary text-secondary-foreground border border-secondary/20 hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive/10 text-destructive border border-destructive/20',
        outline: 'text-foreground border-border',
        // Status variants (semi-transparent backgrounds)
        success: 'border-transparent bg-success/10 text-success border border-success/20',
        warning: 'border-transparent bg-warning/10 text-warning border border-warning/20',
        info: 'border-transparent bg-primary/10 text-primary border border-primary/20',
        premium: 'border-transparent bg-secondary text-secondary-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
